import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CallBack from '../../../../Shared/CallBack/CallBack';

const CallBackPage = (props) => {
const memoText = "מנוי " + props.subscriber + " נרשם ל-CB במסגרת " + props.wizardName + " בגלל סטאטוס " + props.resultMessage;
const dwhParams = {channel: 'WebsitePrivate' ,area: 'Support' , subArea: 'SupportGuides'};

return (
      <div className='call-back-page'>
        <CallBack subjectCode={props.callBackSubjectCode} subTitle={props.callBackText} contactNumber={props.contactNumber} memoCode={props.memoCode} memoText={memoText} dwhParams={dwhParams} />
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    contactNumber : state.authentication?.loginData?.userDetails?.contactNumber,
    subscriber : state.localCellularTroubleshootingWizardBlock.subscriber,
    callBackSubjectCode: state.localCellularTroubleshootingWizardBlock.epiBlockData.callBackSubjectCode,
    callBackText: state.localCellularTroubleshootingWizardBlock.epiBlockData.callBackText,
    resultMessage: state.localCellularTroubleshootingWizardBlock.resultMessage,
    memoCode: state.localCellularTroubleshootingWizardBlock.epiBlockData.memoCode,
    wizardName: state.localCellularTroubleshootingWizardBlock.wizardName
  };
};

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(CallBackPage);
